import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'reactstrap'
import clsx from 'clsx';

import { CardHelp, Custodian } from 'types';

import { Icon, IconName } from '../Icon/Icon';
import { Topography } from '../Topography/Topography';
import styles from './Card.module.scss';
import { StatusMarker } from '../StatusMarker/StatusMarker';
import ReactGA from 'hooks/useGA';
import requestRecord from 'assets/images/request_record.png';
import requestform from 'assets/images/request_form.png';
import closeBtn from 'assets/images/close_btn.png';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'hooks';
import { setFormRequestProvider, setFormRequestForms } from 'store/actions/formRequest.action';
import { getContodianDetails } from 'store/actions/favouriteCustodians.action';
import { setRecordRequestProvider } from 'store/actions/recordRequest.action';

type CardBaseProps = {
  description: string;
  title: string;
  iconName?: IconName;
  comingSoon?: boolean
};
  localStorage.setItem('language', '');
const CardBase: React.FC<CardBaseProps> = ({ description, title, iconName, comingSoon }) => {
  return (
    <>
      <div className='d-flex align-items-center'>
        <div className={styles.icon}>
          <Icon name={iconName || 'star'} />
        </div>
        {comingSoon && <StatusMarker className='ml-3'>Coming Soon</StatusMarker>}
      </div>
      <Topography.H4>{title}</Topography.H4>
      <p>{description}</p>
    </>
  );
};

type CardHelpProps = {
  data?: CardHelp;
  className?: string;
};

const Help: React.FC<CardHelpProps> = ({ data, className }) => {
  if (!data) return null;

  const handleLinkClick = () => {
    ReactGA.event({
      category: 'Placard',
      action: 'Clicked',
      label: data.title
    })
  }
  return (
    <div className={clsx(styles['card-wrapper'], className, data.comingSoon ? styles['comming-soon'] : '')} >
      {data.comingSoon ? (<>
        <div className={styles.comingSoonLayover}>
          <div className={styles.comingSoonBtn}>Coming Soon</div>
        </div>
        <CardBase description={data.description} title={data.title} iconName={data.iconName} comingSoon={true} />
      </>) : (
        <Link to={data.url} onClick={handleLinkClick}>
          <CardBase description={data.description} title={data.title} iconName={data.iconName} />
        </Link>
      )}
    </div >
  );
};
const iconName ='star';
type CardFavoriteProps = {
  data?: Custodian;
  className?: string;
  onClick?: (data: Custodian) => void;
  withDelete?: boolean;
  handleDelete?: () => void;
};

const Favorite: React.FC<CardFavoriteProps> = ({ data, className, onClick, handleDelete, withDelete }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false)
  const [requestModal, setRequestmodal] = useState<boolean>(false)
  const [recordDetails, setRecordDetails] = useState<any>([]);
  if (!data) return null;
  const { id, address1, address2, city, state, name, zipcode } = data;
  const selectedProvider =  data
  const descripton = `${address1}, ${address2 && `${address2},`} ${city}, ${state} ${zipcode}`;
  const openRequestModal = () => {
    setRequestmodal(!requestModal)
  }
  const recordRequestCreation = (provider: any) => {
    dispatch(
      getContodianDetails({ name: provider.name, id: provider.id }, true, custodian => {
        dispatch(setRecordRequestProvider({ ...custodian, selectedLocation: provider.selectedLocation }));
        navigate('/record-request/patient');
      }),
    );
    
  };
  const formRequestCreation = (provider: any) => {
    dispatch(
      getContodianDetails({ name: provider.name, id: provider.id }, true, custodian => {
        dispatch(setFormRequestProvider({ ...custodian, selectedLocation: provider.selectedLocation }));
        navigate('/form-request/patient');
        // dispatch(setFormRequestForms(custodian.patient_form_templates || []));
      }),
    );
  };
  if (withDelete)
    return (
      <div className='col-12 col-md-4 mb-3'>
        <div className={clsx(styles['card-wrapper'])} onClick={onClick && onClick.bind(null, data)}>
          <div className='mt-2' id={`FavoriteCustodianDescription${id}`}>
            <div className={styles['title']}>{name}</div>
            <div className={clsx(styles['description'], 'mt-2')}>
              {address1} {address2} <br />
              {city}, {state} {zipcode}
            </div>
            <div className='mt-3 text-primary text-underline'>
              <span onClick={handleDelete}>Remove from favorites</span>
            </div>
          </div>
          <Tooltip placement="top" isOpen={isTooltipOpen} target={`FavoriteCustodianDescription${id}`} toggle={() => setTooltipOpen(isTooltipOpen => !isTooltipOpen)}>
            <b>{name}</b><br />
            {descripton}
          </Tooltip>
        </div>
      </div>
    );
  else
    return (
      <div className={styles['root']+ ' custodian_itms'}  >
        {/* <Icon className={styles.icon} name={'star'} /> */}
        {/* <div className='mt-2' id={`FavoriteCustodianDescription${id}`}>
          <div className={styles['title']}>{name}</div>
          <div className={styles['description']}>{descripton}</div>
        </div>
        <Tooltip placement="top" isOpen={isTooltipOpen} target={`FavoriteCustodianDescription${id}`} toggle={() => setTooltipOpen(isTooltipOpen => !isTooltipOpen)}>
          <b>{name}</b><br />
          {descripton}
        </Tooltip>
        <div className='align-self-start justify-self-end ml-3 mt-3'>
          <button className='btn_custodian' name='' value=''> Select Provider </button>
        </div> */}
        {/* {withDelete && <Icon name="close" className={styles['delete-icon']} onClick={handleDelete} />} */}
        <div className='ml-3'>
          <div className='justify-self-start'>
            <div className={`d-flex align-items-center`}>
              <Topography.H4 className='cus_name_heading'>{name}</Topography.H4>
            </div>
            <p>{descripton}</p>
            {/* {specialty.length > 0 && (<div className='mt-2 custom_txt_wrap'><b>Specialty</b>:- {specialty?.join(', ')}</div>)} */}
          </div>
        </div>
        <div className='align-self-start ml-auto mt-3 fav_icons'>
          <Icon className={styles.icon} name={iconName} onClick={handleDelete} />
        </div>
        <div className='align-self-start justify-self-end ml-3 mt-3'>
          <button className='btn_custodian' name='' value='' onClick={openRequestModal}> Select Provider </button>
        </div>
        {requestModal ? (
            <div className='request_modal text-center'>
            <div className='request_modal_body'>
                <div className='req_type_txt'>Select Request Type <span className='close_icons' onClick={openRequestModal}><img src={closeBtn} /></span></div>
                <div className='request_option'>
                  <div className='request_record'>
                    <a href='javascript:void(0)' onClick={()=>recordRequestCreation(selectedProvider)}>
                      <img src={requestRecord} alt=''/>
                      <div className='req_txt'>Records Request</div>
                    </a>
                  </div>
                  <div className='request_form'>
                   <a href='javascript:void(0)' onClick={()=>formRequestCreation(selectedProvider)}>
                    <img src={requestform} alt=''/>
                    <div className='req_txt'>Forms Request</div>
                    </a>
                  </div>
                </div>
            </div>
        </div>
        ):null}
      </div>
    );
};

export const Card = {
  Help,
  Favorite,
};
